import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { FarmController } from 'src/controllers/farm.controller'
import { FarmDto } from 'src/dto/farm.dto'

const farmController = new FarmController()

export function useGetFarmList() {
  const { user } = useAuth()

  return useQuery<FarmDto[], Error>({
    queryKey: ['getFarmList', user?.username],
    queryFn: () => farmController.getFarmList(user?.username!),
    enabled: !!user?.username
  })
}
